/**
 * Starter briefs.
 *
 * These are not labels with a word behind them. A one-line request produces a
 * one-line app: the model has to invent the subject, the sections, the data
 * and the tone, and it invents the same generic ones every time. Each brief
 * here names a concrete business, the screens it needs and the shape of its
 * data, which is the difference between a demo and something worth iterating
 * on. Anyone can edit the text before sending — that is the point of putting
 * it in the composer rather than sending it straight off.
 */

export const STARTERS = [
  {
    id: "landing",
    label: "Landing page",
    prompt:
      "A landing page for Meridian, a small studio that restores vintage film cameras in Lisbon. " +
      "Hero with a clear proposition and one call to action, three services with real prices in euros, " +
      "a short section on the restoration process, four customer quotes with names and cities, " +
      "an FAQ, and a contact form with validation. Warm, editorial, print-inspired — not a SaaS template.",
  },
  {
    id: "crm",
    label: "Personal CRM",
    prompt:
      "A personal CRM for keeping up with professional contacts. List with search and filtering by tag, " +
      "a detail panel per contact with notes and interaction history, a 'needs a nudge' view for anyone " +
      "not contacted in 90 days, and add/edit forms. Seed it with about 15 believable contacts across " +
      "different industries. Keyboard-navigable, dense, calm — closer to a desktop tool than a website.",
  },
  {
    id: "tasks",
    label: "Task board",
    prompt:
      "A kanban task board for a three-person design team. Columns for Backlog, In progress, Review and " +
      "Done, drag and drop between them, task cards with an assignee, a due date and a priority, a filter " +
      "by assignee, and a counter per column. Seed it with about 12 realistic tasks. Empty columns must " +
      "say what to do rather than sit blank.",
  },
  {
    id: "inventory",
    label: "Inventory tracker",
    prompt:
      "An inventory tracker for an independent bookshop. Table of stock with title, author, ISBN, quantity " +
      "and cost, sortable columns, search, a low-stock warning under five units, and forms to add stock or " +
      "record a sale. Show the total stock value. Seed it with about 20 real books with plausible prices " +
      "in pounds. Legible at a glance from across a counter.",
  },
  {
    id: "dashboard",
    label: "Analytics dashboard",
    prompt:
      "An analytics dashboard for a subscription coffee company. Revenue, active subscribers, churn and " +
      "average order value as headline figures with change against last month, a 12-month revenue chart, " +
      "a breakdown by plan, and a table of recent orders. Use inline SVG for the charts, no chart library. " +
      "Plausible seed data with real seasonality, not a straight line up.",
  },
  {
    id: "blog",
    label: "Blog",
    prompt:
      "A blog for a writer covering urban transport policy. Index of posts with title, date, reading time " +
      "and excerpt, a full post view with real long-form typography, filtering by topic, and an about page. " +
      "Write three complete posts of 400 to 600 words each with genuine opinions, not placeholder text. " +
      "Reading comfort comes first: measure, line height and hierarchy.",
  },
  {
    id: "survey",
    label: "Survey builder",
    prompt:
      "A survey builder. Create a survey, add questions of several types (short text, long text, multiple " +
      "choice, rating), reorder them, preview the survey as a respondent would see it, and see collected " +
      "responses summarised. Validation on required fields, and a clear empty state before any question " +
      "has been added.",
  },
];
